import { Notify } from 'vant'
import { invoiceRequest, businessRequest } from '@services'
export default {
  namespaced: true,
  state: {
    companyNameList: [],
    selectGoods: [],
    goodsLoading: false,
    loading: false
  },
  actions: {
    async getCompanyList ({ commit }, name) {
      const data = await businessRequest.qrcode.getSmartTitle({ companyName: name })
      if (data.success) {
        await commit('setCompanyNameList', data.result)
      } else {
        Notify({ type: 'danger', message: data.message })
      }
    },
    async getSelectGoods ({ commit }, secretKey) {
      await commit('setGoodsLoading', true)
      const data = await invoiceRequest.auditInvoicing.getSelectGoods({ secretKey })
      if (data.success) {
        await commit('setSelectGoods', data.result)
      } else {
        Notify({ type: 'danger', message: data.message })
      }
      await commit('setGoodsLoading', false)
    },
    async saveInvoiceInfo ({ commit }, invoiceInfo) {
      await commit('setLoading', true)
      const data = await invoiceRequest.auditInvoicing.saveAuditInvoiceing(invoiceInfo)
      if (data.success) {
        await commit('setLoading', false)
        return true
      } else {
        Notify({ type: 'danger', message: data.message })
      }
      await commit('setLoading', false)
    }
  },
  mutations: {
    setCompanyNameList (state, companyNameList) {
      state.companyNameList = companyNameList
    },
    setSelectGoods (state, selectGoods) {
      state.selectGoods = selectGoods
    },
    setGoodsLoading (state, goodsLoading) {
      state.goodsLoading = goodsLoading
    },
    setLoading (state, loading) {
      state.loading = loading
    }
  }
}
